import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'carritoEstado'
})
export class CarritoEstadoPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(value: unknown): SafeHtml {
    let label = '';
    let cssClass = '';
    let icon = '';
    let strong = false;

    // 1 pendiente, 2 empezada, 3 acabada, 4 asignado a pedido, 8 error
    switch (value) {
      case '1':
        label = 'Pendiente';
        cssClass = 'badge-estado-warning';
        break;
      case '2':
        label = 'Recogida empezada';
        cssClass = 'badge-estado-info';
        break;
      case '3':
        label = 'Recogida acabada';
        cssClass = 'badge-estado-success';
        strong = true;
        break;
      case '4':
        label = 'Asignado a pedido';
        cssClass = 'badge-estado-success';
        strong = true;
        break;
      case '8':
        label = 'Incidencia';
        cssClass = 'badge-estado-danger';
        strong = true;
        break;
      default:
        return this.sanitizer.bypassSecurityTrustHtml(`<span class="badge badge-estado-muted">Desconocido</span>`);
    }

    // Construir HTML final
    const text = strong ? `<strong>${label}</strong>` : label;
    const html = `<span class="badge ${cssClass}">${icon} ${text}</span>`;

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}